import React from 'react';
import { Box, Container, Toolbar } from '@mui/material';

const CorporateLayout = ({ children, maxWidth = 'lg', sx = {} }) => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
      <Toolbar /> {/* Spacer for fixed AppBar */}
      
      <Container 
        maxWidth={maxWidth} 
        sx={{ 
          py: 4,
          minHeight: 'calc(100vh - 64px)', // Account for header
          ...sx
        }}
      >
        {children}
      </Container>
      
    </Box>
  );
};

export default CorporateLayout;